import React,{useState,useEffect} from "react";
import Modal from "../../components/Modal";
import Topbar from "../../components/Topbar";
import api from "../../services/api";

const fmt = v => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const MESES = ["Janeiro","Fevereiro","Marco","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const DIAS  = ["Dom","Seg","Ter","Qua","Qui","Sex","Sab"];

const STATUS = {
  AGENDADO:    {l:"Agendado",    cor:"var(--z-blue)",     bg:"#dbeafe"},
  EM_EXECUCAO: {l:"Em Execucao", cor:"var(--z-warning-text)", bg:"#fef3c7"},
  CONCLUIDO:   {l:"Concluido",   cor:"var(--z-success-text)", bg:"#dcfce7"},
  CANCELADO:   {l:"Cancelado",   cor:"var(--z-danger-text)",  bg:"#fee2e2"},
};

const VAZIO = {
  cliente:"", pedido:"", tecnico:"", status:"AGENDADO", tipo_cliente:"CONSUMIDOR",
  data_agendada:"", endereco:"", cep:"", cidade:"", estado:"",
  descricao:"", observacoes:"", valor_mo:"0", valor_materiais:"0", valor_total:"0"
};

function StatusBadge({status}){
  const s = STATUS[status];
  if(!s) return null;
  return <span style={{fontSize:11,padding:"2px 8px",borderRadius:4,fontWeight:600,background:s.bg,color:s.cor}}>{s.l}</span>;
}

function Calendario({ordens}){
  const agora = new Date();
  const [mes,setMes] = useState(agora.getMonth());
  const [ano,setAno] = useState(agora.getFullYear());
  const primeiro = new Date(ano,mes,1).getDay();
  const dias     = new Date(ano,mes+1,0).getDate();
  const celulas  = [...Array(primeiro).fill(null), ...Array.from({length:dias},(_,i)=>i+1)];

  const ordensNoDia = d => {
    const str = [ano, String(mes+1).padStart(2,"0"), String(d).padStart(2,"0")].join("-");
    return ordens.filter(o=>o.data_agendada?.slice(0,10)===str);
  };

  return(
    <div className="card mb-16" style={{padding:16}}>
      <div className="flex-row mb-16">
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mes===0){setMes(11);setAno(a=>a-1);}else setMes(m=>m-1);}}>‹</button>
        <strong style={{fontSize:15,minWidth:160,textAlign:"center"}}>{MESES[mes]} {ano}</strong>
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mes===11){setMes(0);setAno(a=>a+1);}else setMes(m=>m+1);}}>›</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
        {DIAS.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:600,color:"var(--z-text-muted)",padding:"4px 0"}}>{d}</div>)}
        {celulas.map((dia,i)=>{
          if(!dia) return <div key={"e"+i}/>;
          const ords = ordensNoDia(dia);
          const hoje = dia===agora.getDate()&&mes===agora.getMonth()&&ano===agora.getFullYear();
          return(
            <div key={dia} style={{minHeight:64,border:"1px solid "+(hoje?"var(--z-blue)":"var(--z-border)"),borderRadius:6,padding:"4px 6px",background:hoje?"#eff6ff":"#fff"}}>
              <div style={{fontSize:12,fontWeight:hoje?700:400,color:hoje?"var(--z-blue)":"var(--z-text-secondary)",marginBottom:2}}>{dia}</div>
              {ords.map(o=>(
                <div key={o.id} title={"OS#"+o.id+" - "+o.cliente_nome}
                  style={{fontSize:10,background:STATUS[o.status]?.bg,color:STATUS[o.status]?.cor,borderRadius:3,padding:"1px 4px",marginBottom:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                  #{o.id} {o.cliente_nome}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div className="flex-row" style={{marginTop:8,flexWrap:"wrap",fontSize:11}}>
        {Object.entries(STATUS).map(([k,{l,bg,cor}])=>(
          <span key={k}><span style={{display:"inline-block",width:12,height:12,background:bg,borderRadius:2,marginRight:4,verticalAlign:"middle"}}/>{l}</span>
        ))}
      </div>
    </div>
  );
}

function Mapa({ordens}){
  useEffect(()=>{
    if(!document.getElementById("leaflet-css")){
      const link=document.createElement("link"); link.id="leaflet-css"; link.rel="stylesheet"; link.href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"; document.head.appendChild(link);
      const s=document.createElement("script"); s.src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"; s.onload=init; document.head.appendChild(s);
    } else init();
  },[ordens]);

  const init=()=>{
    if(!window.L) return;
    const L=window.L, el=document.getElementById("mapa-servicos");
    if(!el) return;
    if(el._leaflet_id){el._leaflet_id=null;el.innerHTML="";}
    const map=L.map("mapa-servicos").setView([-23.5505,-46.6333],11);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",{attribution:"© OpenStreetMap"}).addTo(map);
    ordens.forEach(o=>{
      if(!o.latitude||!o.longitude) return;
      const cor=STATUS[o.status]?.cor||"#6b7280";
      const icon=L.divIcon({html:`<div style="background:${cor};width:14px;height:14px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.3)"></div>`,iconSize:[14,14],className:""});
      L.marker([parseFloat(o.latitude),parseFloat(o.longitude)],{icon}).addTo(map)
        .bindPopup(`<strong>OS #${o.id}</strong><br/>${o.cliente_nome}<br/><span style="color:${cor};font-weight:600">${STATUS[o.status]?.l||o.status}</span>`);
    });
  };

  return(
    <div className="mb-16">
      {!ordens.some(o=>o.latitude)&&(
        <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:12,fontSize:13,marginBottom:8}}>
          Nenhuma OS com coordenadas cadastradas.
        </div>
      )}
      <div id="mapa-servicos" style={{height:450,borderRadius:8,border:"1px solid var(--z-border)"}}/>
    </div>
  );
}

function LinhaOS({o, onEditar, onExcluir, onMudarStatus}){
  const [open,setOpen]=useState(false);
  return(
    <React.Fragment>
      <tr className="tr-expandable" onClick={()=>setOpen(v=>!v)}>
        <td className="td-mono">#{o.id}</td>
        <td><strong>{o.cliente_nome}</strong></td>
        <td><span style={{fontSize:11,padding:"2px 8px",borderRadius:4,background:o.tipo_cliente==="ARQ_ENG"?"#f0f4ff":"#f0fdf4",color:o.tipo_cliente==="ARQ_ENG"?"var(--z-blue)":"#16a34a"}}>{o.tipo_cliente==="ARQ_ENG"?"Arq/Eng":"Consumidor"}</span></td>
        <td className="fs-12 text-secondary">{o.tecnico_nome||"—"}</td>
        <td className="fs-12 text-secondary">{o.data_agendada?new Date(o.data_agendada).toLocaleString("pt-BR",{dateStyle:"short",timeStyle:"short"}):"—"}</td>
        <td className="td-r fw-600">R$ {fmt(o.valor_total)}</td>
        <td><StatusBadge status={o.status}/></td>
        <td className="td-r"><i className={"ti ti-chevron-"+(open?"up":"down")} style={{fontSize:14,color:"var(--z-text-muted)"}}/></td>
      </tr>
      {open&&(
        <tr className="tr-dropdown"><td colSpan={8}>
          <div className="dropdown-content">
            {o.endereco&&<div className="fs-13 mb-8"><i className="ti ti-map-pin"/> {o.endereco}{o.cidade&&`, ${o.cidade}/${o.estado}`}</div>}
            {o.descricao&&<div className="fs-13 mb-8 text-secondary">{o.descricao}</div>}
            {(o.itens||[]).length>0&&(
              <table style={{width:"100%",fontSize:12,marginBottom:12}}>
                <thead><tr className="bg-page"><th className="td-l">Produto</th><th className="td-r">Qtd</th><th className="td-r">Unit</th><th className="td-r">Total</th></tr></thead>
                <tbody>{o.itens.map(it=>(
                  <tr key={it.id} style={{borderBottom:"1px solid var(--z-border)"}}>
                    <td className="td-p">{it.produto_codigo} — {it.produto_nome}</td>
                    <td className="td-r">{fmt(it.quantidade)}</td>
                    <td className="td-r">R$ {fmt(it.valor_unit)}</td>
                    <td className="td-r fw-600">R$ {fmt(it.valor_total)}</td>
                  </tr>
                ))}</tbody>
              </table>
            )}
            <div className="flex-row mb-12 fs-13">
              <span>MO: <strong>R$ {fmt(o.valor_mo)}</strong></span>
              <span>Materiais: <strong>R$ {fmt(o.valor_materiais)}</strong></span>
              <span>Total: <strong className="text-blue">R$ {fmt(o.valor_total)}</strong></span>
            </div>
            {o.observacoes&&<div className="fs-12 text-secondary mb-8">Obs: {o.observacoes}</div>}
            <div className="produto-dropdown-acoes">
              <button className="btn btn-secondary fs-12" onClick={e=>{e.stopPropagation();onEditar(o);}}>
                <i className="ti ti-edit"/> Editar
              </button>
              <button className="btn btn-danger fs-12" onClick={e=>{e.stopPropagation();onExcluir(o.id);}}>
                <i className="ti ti-trash"/> Excluir
              </button>
              {o.status==="AGENDADO"&&<button className="btn btn-primary fs-12" onClick={e=>{e.stopPropagation();onMudarStatus(o.id,"EM_EXECUCAO");}}>Iniciar Execucao</button>}
              {o.status==="EM_EXECUCAO"&&<button className="btn btn-primary fs-12" onClick={e=>{e.stopPropagation();onMudarStatus(o.id,"CONCLUIDO");}}>Concluir OS</button>}
              {!["CANCELADO","CONCLUIDO"].includes(o.status)&&<button className="btn btn-danger fs-12" onClick={e=>{e.stopPropagation();onMudarStatus(o.id,"CANCELADO");}}>Cancelar</button>}
            </div>
          </div>
        </td></tr>
      )}
    </React.Fragment>
  );
}

export default function Servicos(){
  const [ordens,setOrdens]     = useState([]);
  const [clientes,setClientes] = useState([]);
  const [tecnicos,setTecnicos] = useState([]);
  const [produtos,setProdutos] = useState([]);
  const [pedidos,setPedidos]   = useState([]);
  const [loading,setLoading]   = useState(true);
  const [busca,setBusca]       = useState("");
  const [filtroStatus,setFiltroStatus] = useState("");
  const [abaVis,setAbaVis]     = useState("lista");
  const [modalForm,setModalForm] = useState(null);
  const [form,setForm]         = useState(VAZIO);
  const [itens,setItens]       = useState([]);
  const [salvando,setSalvando] = useState(false);

  const carregar=()=>{
    setLoading(true);
    Promise.all([
      api.get("/servicos/ordens/?page_size=1000"),
      api.get("/clientes/contatos/?page_size=1000"),
      api.get("/funcionarios/funcionarios/?page_size=1000"),
      api.get("/produtos/produtos/?page_size=1000"),
      api.get("/vendas/pedidos/?page_size=1000"),
    ]).then(([oR,cR,fR,prR,pedR])=>{
      setOrdens(oR.data.results||oR.data);
      setClientes((cR.data.results||cR.data).filter(c=>c.tipo!=="FORNECEDOR"));
      setTecnicos(fR.data.results||fR.data);
      setProdutos((prR.data.results||prR.data).filter(p=>p.grupo==="PRODUTO_FINAL"));
      setPedidos(pedR.data.results||pedR.data);
    }).finally(()=>setLoading(false));
  };
  useEffect(()=>{carregar();},[]);

  const setF=(f,v)=>setForm(prev=>{
    const n={...prev,[f]:v};
    if(["valor_mo","valor_materiais"].includes(f)){
      n.valor_total=(parseFloat(f==="valor_mo"?v:n.valor_mo||0)+parseFloat(f==="valor_materiais"?v:n.valor_materiais||0)).toFixed(2);
    }
    return n;
  });

  const setItem=(idx,field,val)=>setItens(prev=>{
    const n=[...prev]; n[idx]={...n[idx],[field]:val};
    if(["quantidade","valor_unit"].includes(field)){
      const q=parseFloat(field==="quantidade"?val:n[idx].quantidade||0);
      const p=parseFloat(field==="valor_unit"?val:n[idx].valor_unit||0);
      n[idx].valor_total=(q*p).toFixed(2);
    }
    const mat=n.reduce((s,i)=>s+parseFloat(i.valor_total||0),0);
    setForm(f=>({...f,valor_materiais:mat.toFixed(2),valor_total:(parseFloat(f.valor_mo||0)+mat).toFixed(2)}));
    return n;
  });

  const selectProduto=(idx,prodId)=>{
    const p=produtos.find(x=>x.id===parseInt(prodId));
    if(!p) return;
    setItens(prev=>{
      const n=[...prev]; n[idx]={...n[idx],produto:prodId,valor_unit:parseFloat(p.preco_custo).toFixed(4),valor_total:parseFloat(p.preco_custo).toFixed(2)};
      const mat=n.reduce((s,i)=>s+parseFloat(i.valor_total||0),0);
      setForm(f=>({...f,valor_materiais:mat.toFixed(2),valor_total:(parseFloat(f.valor_mo||0)+mat).toFixed(2)}));
      return n;
    });
  };

  const addItem=()=>setItens(p=>[...p,{produto:"",quantidade:"1",valor_unit:"0",valor_total:"0"}]);
  const removeItem=idx=>{
    const n=itens.filter((_,i)=>i!==idx);
    setItens(n);
    const mat=n.reduce((s,i)=>s+parseFloat(i.valor_total||0),0);
    setForm(f=>({...f,valor_materiais:mat.toFixed(2),valor_total:(parseFloat(f.valor_mo||0)+mat).toFixed(2)}));
  };

  const buscarCoordenadas=async(end,cid,est)=>{
    if(!end) return;
    try{const r=await fetch("https://nominatim.openstreetmap.org/search?q="+encodeURIComponent(end+", "+cid+", "+est+", Brasil")+"&format=json&limit=1");const d=await r.json();if(d[0])setForm(f=>({...f,latitude:d[0].lat,longitude:d[0].lon}));}catch{}
  };

  const salvar=async()=>{
    if(!form.cliente){alert("Selecione o cliente.");return;}
    setSalvando(true);
    try{
      const dados={...form,cliente:parseInt(form.cliente),tecnico:form.tecnico?parseInt(form.tecnico):null,pedido:form.pedido?parseInt(form.pedido):null,data_agendada:form.data_agendada||null};
      let os;
      if(modalForm==="novo"){const r=await api.post("/servicos/ordens/",dados);os=r.data;}
      else{const r=await api.put("/servicos/ordens/"+form.id+"/",dados);os=r.data;const old=await api.get("/servicos/itens/?os="+os.id);for(const it of(old.data.results||old.data))await api.delete("/servicos/itens/"+it.id+"/");}
      for(const it of itens.filter(i=>i.produto)) await api.post("/servicos/itens/",{...it,os:os.id});
      carregar();setModalForm(null);
    }catch{alert("Erro ao salvar.");}
    finally{setSalvando(false);}
  };

  const abrirNovo=()=>{setForm(VAZIO);setItens([]);setModalForm("novo");};
  const abrirEditar=async o=>{
    setForm({...o,cliente:String(o.cliente),tecnico:o.tecnico?String(o.tecnico):"",pedido:o.pedido?String(o.pedido):""});
    const r=await api.get("/servicos/itens/?os="+o.id);
    setItens((r.data.results||r.data).map(i=>({...i,produto:String(i.produto)})));
    setModalForm("editar");
  };
  const excluir=async id=>{if(!window.confirm("Excluir OS?"))return;await api.delete("/servicos/ordens/"+id+"/");carregar();};
  const mudarStatus=async(id,st)=>{await api.patch("/servicos/ordens/"+id+"/",{status:st});setOrdens(prev=>prev.map(o=>o.id===id?{...o,status:st}:o));};

  const filtradas=ordens.filter(o=>(!filtroStatus||o.status===filtroStatus)&&((o.cliente_nome||"").toLowerCase().includes(busca.toLowerCase())||String(o.id).includes(busca)));

  const footer=(<><button className="btn btn-secondary" onClick={()=>setModalForm(null)}>Cancelar</button><button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button></>);

  return(<>
    <Topbar title="Servicos"/>
    <div className="erp-content">
      <div className="page-toolbar">
        <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> Nova OS</button>
        <div className="flex-row" style={{flexWrap:"wrap",gap:4}}>
          {["","AGENDADO","EM_EXECUCAO","CONCLUIDO","CANCELADO"].map(s=>(
            <button key={s} className={"btn btn-secondary"+(filtroStatus===s&&abaVis==="lista"?" aba-ativa":"")}
              style={{fontSize:11,padding:"4px 10px"}} onClick={()=>{setFiltroStatus(s);setAbaVis("lista");}}>
              {s?STATUS[s]?.l:"Todos"}{s&&<span className="fs-11"> ({ordens.filter(o=>o.status===s).length})</span>}
            </button>
          ))}
          <button className={"btn btn-secondary"+(abaVis==="calendario"?" aba-ativa":"")} style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setAbaVis("calendario")}>
            <i className="ti ti-calendar"/> Calendario
          </button>
          <button className={"btn btn-secondary"+(abaVis==="mapa"?" aba-ativa":"")} style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setAbaVis("mapa")}>
            <i className="ti ti-map"/> Mapa
          </button>
        </div>
        <input className="form-input" style={{width:220}} placeholder="Buscar cliente ou OS#..." value={busca} onChange={e=>setBusca(e.target.value)}/>
      </div>

      {abaVis==="calendario"&&<Calendario ordens={ordens}/>}
      {abaVis==="mapa"&&<Mapa ordens={ordens}/>}
      {abaVis==="lista"&&(
        <div className="card">
          <div className="table-wrapper">
            {loading?<div className="table-empty">Carregando...</div>:
             !filtradas.length?<div className="table-empty">Nenhuma OS encontrada.</div>:(
              <table>
                <thead><tr><th>OS#</th><th>Cliente</th><th>Tipo</th><th>Tecnico</th><th>Data Agendada</th><th className="td-r">Total</th><th>Status</th><th></th></tr></thead>
                <tbody>{filtradas.map(o=><LinhaOS key={o.id} o={o} onEditar={abrirEditar} onExcluir={excluir} onMudarStatus={mudarStatus}/>)}</tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>

    {modalForm&&(
      <Modal title={modalForm==="novo"?"Nova OS":"Editar OS"} onClose={()=>setModalForm(null)} size="xl" footer={footer}>
        <div className="form-grid">
          <div className="form-group col-span-2">
            <label className="form-label">Cliente</label>
            <select className="form-select" value={form.cliente||""} onChange={e=>setF("cliente",e.target.value)}>
              <option value="">-- Selecione --</option>
              {clientes.map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
          </div>
          <div className="form-group"><label className="form-label">Tipo cliente</label><select className="form-select" value={form.tipo_cliente||""} onChange={e=>setF("tipo_cliente",e.target.value)}><option value="CONSUMIDOR">Consumidor Final</option><option value="ARQ_ENG">Arq/Eng</option></select></div>
          <div className="form-group"><label className="form-label">Tecnico</label><select className="form-select" value={form.tecnico||""} onChange={e=>setF("tecnico",e.target.value)}><option value="">-- Selecione --</option>{tecnicos.map(t=><option key={t.id} value={t.id}>{t.nome}</option>)}</select></div>
          <div className="form-group"><label className="form-label">Data agendada</label><input className="form-input" type="datetime-local" value={form.data_agendada||""} onChange={e=>setF("data_agendada",e.target.value)}/></div>
          <div className="form-group"><label className="form-label">Status</label><select className="form-select" value={form.status||""} onChange={e=>setF("status",e.target.value)}>{Object.entries(STATUS).map(([v,{l}])=><option key={v} value={v}>{l}</option>)}</select></div>
          <div className="form-group"><label className="form-label">Pedido vinculado</label><select className="form-select" value={form.pedido||""} onChange={e=>setF("pedido",e.target.value)}><option value="">-- Nenhum --</option>{pedidos.map(p=><option key={p.id} value={p.id}>#{p.id} - {p.cliente_nome}</option>)}</select></div>
        </div>
        <div className="form-group"><label className="form-label">Endereco</label><input className="form-input" value={form.endereco||""} onChange={e=>setF("endereco",e.target.value)} placeholder="Rua, numero, bairro"/></div>
        <div className="form-grid">
          <div className="form-group"><label className="form-label">CEP</label><input className="form-input" value={form.cep||""} onChange={e=>setF("cep",e.target.value)}/></div>
          <div className="form-group"><label className="form-label">Cidade</label><input className="form-input" value={form.cidade||""} onChange={e=>setF("cidade",e.target.value)}/></div>
          <div className="form-group"><label className="form-label">Estado</label><input className="form-input" value={form.estado||""} onChange={e=>setF("estado",e.target.value)} placeholder="SP"/></div>
        </div>
        <div className="flex-row mb-12">
          <button className="btn btn-secondary" className="fs-12" onClick={()=>buscarCoordenadas(form.endereco,form.cidade,form.estado)}><i className="ti ti-map-pin"/> Buscar coordenadas</button>
          {form.latitude&&<span className="fs-12 text-success">✓ {form.latitude}, {form.longitude}</span>}
        </div>
        <div className="form-group"><label className="form-label">Descricao do servico</label><textarea className="form-input" rows={2} value={form.descricao||""} onChange={e=>setF("descricao",e.target.value)}/></div>
        <div className="form-section" style={{marginTop:12}}>Materiais utilizados</div>
        <table style={{width:"100%",fontSize:12,marginBottom:8}}>
          <thead><tr className="bg-page"><th className="td-l">Produto</th><th className="td-r" style={{width:80}}>Qtd</th><th className="td-r" style={{width:120}}>Unit</th><th className="td-r" style={{width:110}}>Total</th><th style={{width:30}}></th></tr></thead>
          <tbody>{itens.map((it,idx)=>(
            <tr key={idx} style={{borderBottom:"1px solid var(--z-border)"}}>
              <td className="td-p"><select className="form-select" style={{fontSize:12,padding:"3px 6px"}} value={it.produto||""} onChange={e=>selectProduto(idx,e.target.value)}><option value="">-- Selecione --</option>{produtos.map(p=><option key={p.id} value={p.id}>{p.codigo} — {p.nome}</option>)}</select></td>
              <td className="td-p"><input type="number" className="form-input" style={{fontSize:12,padding:"3px 6px",textAlign:"right"}} value={it.quantidade} onChange={e=>setItem(idx,"quantidade",e.target.value)}/></td>
              <td className="td-p"><input type="number" className="form-input" style={{fontSize:12,padding:"3px 6px",textAlign:"right"}} value={it.valor_unit} onChange={e=>setItem(idx,"valor_unit",e.target.value)}/></td>
              <td className="td-r fw-600">R$ {fmt(it.valor_total)}</td>
              <td className="td-p"><button className="btn btn-danger" style={{padding:"1px 6px",fontSize:11}} onClick={()=>removeItem(idx)}>×</button></td>
            </tr>
          ))}</tbody>
        </table>
        <button className="btn btn-secondary mb-12" className="fs-12" onClick={addItem}><i className="ti ti-plus"/> Adicionar material</button>
        <div className="form-grid">
          <div className="form-group"><label className="form-label">Valor mao de obra (R$)</label><input className="form-input" type="number" value={form.valor_mo||""} onChange={e=>setF("valor_mo",e.target.value)}/></div>
          <div className="form-group"><label className="form-label">Total</label><input className="form-input" value={"R$ "+fmt(form.valor_total)} readOnly style={{fontWeight:700,color:"var(--z-blue)",background:"var(--z-bg-page)"}}/></div>
        </div>
        <div className="form-group"><label className="form-label">Observacoes</label><textarea className="form-input" rows={2} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/></div>
      </Modal>
    )}
  </>);
}